/* eslint-disable */
import { useMemo, useState } from "react";
import { Button, Divider, Modal, CardContent, Stack, TextField, Box, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import MainCard from "components/MainCard";
import { Controller, useForm } from "react-hook-form";
import { useEffect } from "react";
import { getAttentionObservationsById, getEquipmentAlertsById } from "components/axios/equipmentAlertsAxios";
import dayjs from "utils/dayjs";
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { useEnumApi } from "contexts/EnumApiContext";
import { getEquipmentCategoriesById, getEquipmentCategoriesByQuery, getMasterEquipmentPartsById, getMasterEquipmentPartsByQuery } from "components/axios/equipmentCategoryAxios";
import { useRef } from "react";
import { getMaintenanceTasksById } from "components/axios/maintenanceAxios";
import { LoadingButton } from "@mui/lab";
import FileDownloadIcon from "components/FileDownloadIcon";
import { makeFaultsMessage2, orderString } from "data/data";
import { useSelector } from "react-redux";
import { customFileAxios } from "components/axios/customAxios";
import { Grid2, inputStyle, SectionTitle } from "./CommonModule";
import { CustomMuiDatePicker } from "components/date_picker/CustomMuiDatePicker";
import { CustomMuiDateTimePicker } from "components/date_picker/CustomMuiDateTimePicker";
import MaintenanceFormWrapper from "./MaintenanceFormWrapper";
import { useTranslation } from "react-i18next";
import { isValidDateFormat, isValidDateTimeFormat } from "components/date_picker/dateUtils";
import PermissionButton from "components/PermissionButton";
import { PERMISSIONS } from "config/permissions";

const ConstantInspectionModal = ({alertId,  onRefresh, type}) => {
    const { t } = useTranslation();
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode } = useEnumApi();
    const { name } = useSelector(state => state.user);

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };
    
    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true); setIsLoading(false); };
    const handleClose = () => {setOpen(false); if (onRefresh) onRefresh()};
  
    const { control, register , handleSubmit , reset
        , setValue ,  formState : { isDirty , errors } } = useForm({});

    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);

    const [equipmentAlert, setEquipmentAlert] = useState(null);
    const [fllwActionTypes, setFllwActionTypes] = useState(null);

    const [attentionObservation, setAttentionObservation] = useState({});
    const [maintenanceTask, setMaintenanceTask] = useState({});

    const nextID = useRef(1);
    const [inputFiles, setInputFiles] = useState([]);
  
    function addInputFile(file) {
      const input = {	
          id: nextID.current,
          file: {},
          rFile: file,
      };

      setInputFiles([...inputFiles, input]);
      nextID.current += 1;
    }

    // 삭제
    function deleteInputFile(index) {
        setInputFiles(inputFiles.filter(item => item.id !== index));
    }

    function handleInputFileChange(e, index) {
        if (index > inputFiles.length) return;
        
        
        let inputFilesCopy = [...inputFiles];
        inputFilesCopy[index].file = e.target.files[0];
        inputFilesCopy[index].rFile = null;
        setInputFiles(inputFilesCopy);
    }

    useEffect(()=>{
      const list = getEnumValueByEnumName("FollowActionType");
      if (list) {
        let fllwActionTypeList = list.filter(type=>type.code!=='O1_WAIT');
        setFllwActionTypes(fllwActionTypeList);
      }
    },[getEnumValueByEnumName("FollowActionType")]);

    useEffect(()=>{
      // console.log(alertId);
      if (alertId && open) {
        Promise.all([
          getEquipmentAlertsById(alertId).then((data)=>{
            const fieldChkedAt = data?.fieldChkedAt 
              ? dayjs(data.fieldChkedAt).tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DDTHH:mm:ssZ')
              : data.latestAlertedAt 
                ? dayjs(data?.latestAlertedAt).add(3, 'minute').tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DDTHH:mm:ssZ')
                : dayjs().tz(process.env.REACT_APP_TIMEZONE).format('YYYY-MM-DDTHH:mm:ssZ')
            // setValue('fieldChkedAt', data?.fieldChkedAt ? dayjs(data?.fieldChkedAt).format('YYYY-MM-DDTHH:mm') : dayjs(dayjs(data?.alertedAt).add(3,'minute')).format('YYYY-MM-DDTHH:mm'));
            // {equipmentAlert.fieldChkedAt ? fromServerFormat(equipmentAlert.fieldChkedAt, {format:t('message.common.text.date.format.datetime')}) 
            // : equipmentAlert.latestAlertedAt ? dayjs.tz(equipmentAlert.latestAlertedAt, process.env.REACT_APP_TIMEZONE).add(3,'minute').format(t('message.common.text.date.format.datetime')) 
            // : nowFormat(t('message.common.text.date.format.datetime'))} 
            // console.log('fieldChkedAt', fieldChkedAt);
            setValue('fieldChkedAt', fieldChkedAt);
            setEquipmentAlert(data);
          })
        ]).then((res)=>{
          setIsLoading(true);
        })
      }
    },[alertId, isLoading, open]);

    useEffect(() => {
      if (equipmentAlert && equipmentAlert.fllwActionType && (equipmentAlert.fllwActionType === 'O2_OBSERVE' || equipmentAlert.fllwActionType === 'O3_MNT')) {
        if (equipmentAlert.fllwActionType === 'O2_OBSERVE' && equipmentAlert.atentObserv && equipmentAlert.atentObserv.id) {
          // console.log('O2_OBSERVE');
          getAttentionObservationsById(equipmentAlert.atentObserv.id).then((data2)=>{
            // console.log(data2);
            if (data2) {
              setValue("regUser",(name || null));
              setValue("regYmd",(dayjs(new Date()).format('YYYY-MM-DD')));
              setValue("plannedEndYmd", data2.plannedEndYmd || null);
              setAttentionObservation(data2)
            }
          })
        } else if (equipmentAlert.fllwActionType === 'O3_MNT') {
          //console.log('O3_MNT');
          const equipmentCtgrId = equipmentAlert.equipment.equipmentCtgr.id;
          //console.log('equipmentAlert.equipment.equipmentCtgr.id : ' + equipmentCtgrId);
          if (equipmentCtgrId && equipmentAlert.mntTask && equipmentAlert.mntTask.id) {
            Promise.all([
              getMaintenanceTasksById(equipmentAlert.mntTask.id).then((data2)=>{ // 유지보수내역
                // console.log(data2);
                if (data2) {
                  setMaintenanceTask(data2)
                }
              })
            ]);
          }
        }
      }
    },[equipmentAlert]);

    const alertDtl = useMemo(()=>{
      if (equipmentAlert) {
        let alertDtl = (equipmentAlert?.alertDtl ?? '');
        alertDtl += makeFaultsMessage2(equipmentAlert, getEnumValueByEnumNameAndCode);
        return alertDtl;
      }
      return '';
    }, [equipmentAlert])

    const onSubmit = (data) => {
      console.log(data);   

      if (data.fieldChkedAt != null && data.fieldChkedAt != '' && !isValidDateTimeFormat(data.fieldChkedAt)) {
        handleAlertClick(t('message.common.alert.constantInspection.checkedAt.input'));
        setFileLoading(false);
        return;
      }

      let dto = {
        id : alertId,
        equipment : {
          id : equipmentAlert.equipment.id
        },
        fieldChkedAt : data.fieldChkedAt,
        fieldChkUser : data.fieldChkUser,
        status : "M",  // 점검확인
        fllwActionType : data.fllwActionType
      }

      if (data.fllwActionType === 'O2_OBSERVE') {
        dto.atentObserv = {}
      } else if (data.fllwActionType === 'O3_MNT') {
        dto.mntTask = {}
      }

      console.log(dto);

      let formData = new FormData();
      
      formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
      for (var value2 of formData.entries()) {
        //console.log(value2[0]+', ',value2[1]);
      }

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
              const res = customFileAxios.patch(`/api/equipmentAlerts/${alertId}`, formData).then((res)=>{
                  // console.log(res)
                  //setFileLoading(false);
                  //refreshEquipments();
                  //setFllwActionType(data.fllwActionType);
                  if (data.fllwActionType === 'O2_OBSERVE' || data.fllwActionType === 'O3_MNT') {
                    if (data.fllwActionType === 'O2_OBSERVE') {
                      getAttentionObservationsById(res.data.atentObserv.id).then((data2)=>{
                        console.log(data2);
                        if (data2) {
                          setAttentionObservation(data2)
                          setValue("plannedEndYmd",null);
                          // setValue("reportYmd",null);
                        }
                      })
                    } else if (data.fllwActionType === 'O3_MNT') {
                      getMaintenanceTasksById(res.data.mntTask.id).then((data2)=>{ // 유지보수내역
                        console.log(data2);
                        if (data2) {
                          setMaintenanceTask(data2)
                          // setValue("reportYmd",null);
                        }
                      })
                    }
                    setIsLoading(false);
                    reset();

                    setTimeout(() => {
                      handleAlertClick(t('message.common.alert.write.done'));
                    }, 100);
                  } else {
                    reset();
                    handleClose();
                    handleAlertClick(t('message.common.alert.write.done'));
                  }
              }).catch((err)=>{
                  console.log(err);
                  //setFileLoading(false);
                  handleAlertClick(err.response?.data?.message || err.message);
              });
              return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }
        },
        onClose : () => {
            console.log('close');
        },
        message: t('message.common.alert.write.question'),
      });
    }
    
    const onAttentionObservationSubmit = (data, e) => {
      setFileLoading(true);
      //console.log(111);
      //console.log(data);
      if (data.plannedEndYmd === null || data.plannedEndYmd === '') {
        handleAlertClick(t('message.common.alert.observe.endYmd.input'));
        setFileLoading(false);
        return;
      }
      if (data.plannedEndYmd != null && data.plannedEndYmd != '' && !isValidDateFormat(data.plannedEndYmd)) {
        handleAlertClick(t('message.common.alert.observe.endYmd.input'));
        setFileLoading(false);
        return;
      }

      if (data.regYmd === null || data.regYmd === '') {
        handleAlertClick(t('message.common.alert.observe.startYmd.input'));
        setFileLoading(false);
        return;
      }
      if (data.regYmd != null && data.regYmd != '' && !isValidDateFormat(data.regYmd)) {
        handleAlertClick(t('message.common.alert.observe.startYmd.input'));
        setFileLoading(false);
        return;
      }
      
      let dto = {
        equipmentAlert : {id:alertId},
        equipment : {id:equipmentAlert.equipment.id},
        plannedEndYmd : data.plannedEndYmd,
        regUser : data.regUser,
        regYmd : data.regYmd,
        remark : data.remark,
      }

      let statusReport = {};
      dto.statusReport = statusReport;

      let formData = new FormData();
      let fileCnt = 0;
      if(inputFiles) {
        for (var l=0;l<inputFiles.length;l++) {
            if (inputFiles[l].file && inputFiles[l].file.name) {
                formData.append("statusFiles", inputFiles[l].file);
                fileCnt++;
            }
        }
      }
      
      //console.log("============ formData =============");
      // for (var value of formData.entries()) {
      //     //console.log(value[0]+', ',value[1]);
      // }

      //if((type && type === "modify") && observeStatus === '유효') {  // 수정
        dto.id = attentionObservation.id;
        let rfileCnt = 0;
        if (inputFiles) {
            let rFiles = [];
            for (var a2=0;a2<inputFiles.length;a2++) {
                if (inputFiles[a2].rFile && inputFiles[a2].rFile.id) {
                    rFiles.push({id : inputFiles[a2].rFile.id});
                    rfileCnt++;
                }
            }
            statusReport.reportFiles = rFiles;
        }
        if (attentionObservation.statusReport && attentionObservation.statusReport.id)
          statusReport.id = (attentionObservation.statusReport && attentionObservation.statusReport.id);

        console.log(dto);
        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
        // for (var value2 of formData.entries()) {
        //   console.log(value2[0]+', ',value2[1]);
        // }
        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            try {
                const res = customFileAxios.patch(`/api/attentionObservations/${attentionObservation.id}`, formData).then((res)=>{
                    //console.log(res);
                    handleAlertClick(t('message.common.alert.modify.done'));
                    setFileLoading(false);
                    if (onRefresh) onRefresh();
                    reset();
                    handleClose();
                    //navigate('../modify/'+res.data.id+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    setFileLoading(false);
                    handleAlertClick(err.response?.data?.message || err.message);
                });
                // return res.data;
            } catch (error) {
                console.error("error :", error);
                throw error;
            }
          },
          onClose : () => {
              console.log('close');
              setFileLoading(false);
          },
          message: t('message.common.alert.modify.question'),
        });
      //}
      
      //console.log(222);
    }

    return (
      <>
        {type && type === 'icon' &&
        <PermissionButton
            permission={PERMISSIONS.CONSTANT_INSPECTION_WRITE}
            variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset"}} color="grey"
        >
            <span className="icon_png" style={{color:"#fff"}}><img src={`${process.env.PUBLIC_URL}/img/icon/content_paste_search.png`} alt='' /></span>
        </PermissionButton>
        }
        {(type === null || type === undefined || type === 'button') &&
        <PermissionButton
            permission={PERMISSIONS.CONSTANT_INSPECTION_WRITE}
            variant="contained" onClick={handleOpen} style={{minWidth:"unset", marginLeft:"3px", marginRight:"3px"}}
        >
            {t('message.common.subtitle.constantInspection')}
        </PermissionButton>
        }
        
        {isLoading &&
        <Modal className="pop_box pop_box1 renew_pop_box" open={open} onClose={handleClose}>
          <MainCard title="" modal darkTitle content={false} sx={{ width: 800 }}>
            <div className="modal-header">🚧 {t('message.common.chip.constantInspection')}</div>
            <CardContent>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid2>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "rgb(160, 174, 192)", mb: 1 }}>{t('message.common.subtitle.equipment.level1')}</Typography>
                  <div style={{padding:"10px"}}>{equipmentAlert?.equipment?.equipmentCtgr?.parent?.parent?.name ?? ''}</div> 
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.equipment.level2')}</Typography>
                  <div style={{padding:"10px"}}>{equipmentAlert?.equipment?.equipmentCtgr?.parent?.name ?? ''}</div> 
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.equipment.level3')}</Typography>
                  <div style={{padding:"10px"}}>{equipmentAlert?.equipment?.equipmentCtgr?.name ?? ''}</div> 
                </Box>
              </Grid2>

              <Grid2>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "rgb(160, 174, 192)", mb: 1 }}>{t('message.common.subtitle.equipment.name')}</Typography>
                  <div style={{padding:"10px"}}>{equipmentAlert?.equipment?.equipmentCtgr?.parent?.parent?.name ?? ''}</div> 
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.equipment.number')}</Typography>
                  <div style={{padding:"10px"}}>{equipmentAlert?.equipment?.name ?? ''}</div> 
                </Box>
              </Grid2>

              <Grid2>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "rgb(160, 174, 192)", mb: 1 }}>{t('message.common.subtitle.alertedAt')}</Typography>
                  <div style={{padding:"10px"}}>{dayjs(equipmentAlert.alertedAt).format("YYYY.MM.DD HH:mm") ?? ''}</div> 
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.alertType')}</Typography>
                  <div style={{padding:"10px"}}>{getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType)?.[0]?.title ?? ''}</div> 
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "rgb(160, 174, 192)", mb: 1 }}>{t('message.common.subtitle.alertCategory')}</Typography>
                  <div style={{padding:"10px"}}>{getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory)?.[0]?.title ?? ''}</div> 
                </Box>
              </Grid2>

              <Grid2>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.alertDetail')}</Typography>
                  <div style={{padding:"10px", whiteSpace:"pre-line"}} dangerouslySetInnerHTML={ {__html: alertDtl } }></div> 
                </Box>
              </Grid2>

              {equipmentAlert?.fllwActionType !== 'O1_WAIT' ? 
              <Grid2>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "rgb(160, 174, 192)", mb: 1 }}>{t('message.common.subtitle.constantInspection.checkedAt')}</Typography>
                  <div style={{padding:"10px"}}>{dayjs(equipmentAlert.fieldChkedAt).format("YYYY.MM.DD HH:mm") ?? ''}</div> 
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.constantInspection.confirm.user')}</Typography>
                  <div style={{padding:"10px"}}>{equipmentAlert.fieldChkUser ?? ''}</div> 
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.status')}</Typography>
                  <div style={{padding:"10px"}}>{getEnumValueByEnumNameAndCode("EquipmentAlertStatus", equipmentAlert.status)?.[0]?.title ?? ''}</div> 
                </Box>
              </Grid2>
              :
              <Grid2>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "rgb(160, 174, 192)", mb: 1 }}>{t('message.common.subtitle.constantInspection.checkedAt')}</Typography>
                  <Box>
                      <Controller
                        control={control}
                        name="fieldChkedAt"
                        rules={{
                          required: t('message.common.error.text.constantInspection.checkedAt.input'),
                          validate: (value) => {
                            if (!value) return true;
                            // 만약 서버 포맷(T 포함)으로 이미 정제된 값이라면 통과
                            if (value.includes("T")) return true; 
                            
                            // 사용자가 입력창에 남겨둔 임시 텍스트 검증
                            const normalized = value.trim().replace(/-/g, ".");
                            const parsed = dayjs(normalized, "YYYY.MM.DD HH:mm", true);
                            
                            return (normalized.length === 16 && parsed.isValid()) || t('message.common.error.text.msg.invalid.date.format');
                          }
                        }}
                        render={({ field, fieldState }) => (
                          <CustomMuiDateTimePicker field={field} fieldState={fieldState} />
                        )}
                      />
                      
                      {/* <Controller
                          control={control}
                          name="fieldChkedAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                          <CustomDateTimePicker
                              defaultValue={equipmentAlert.fieldChkedAt ? dayjs(equipmentAlert.fieldChkedAt).format('YYYY-MM-DD HH:mm') : dayjs(dayjs(equipmentAlert.alertedAt).add(3,'minute')).format('YYYY-MM-DD HH:mm')}
                              field={field} style={{width:"96%"}} ref={ref} name={name} value={value} register={register} 
                              setValue={setValue} fieldState={fieldState}
                              requiredMessage={"현장확인 일시를 입력하십시오."}
                              //onChange={(data)=>{setValue(name, dayjs(data).format("YYYY-MM-DD"))}}
                          />
                          )}
                      />
                      {errors.fieldChkedAt && <small role="alert"><br></br>{errors.fieldChkedAt.message}</small>} */}
                  </Box>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.constantInspection.confirm.user')}</Typography>
                  <Box >
                    <TextField style={{width:"96%"}} id="outlined-basic" 
                        aria-invalid={!isDirty ? undefined : errors.fieldChkUser ? "true" : "false"}
                        defaultValue={equipmentAlert.fieldChkUser || name}
                        {...register("fieldChkUser", {
                            required : t('message.common.error.text.constantInspection.confirm.user.input')
                        })}
                        error={!!errors.fieldChkUser} 
                        helperText={errors.fieldChkUser?.message}   
                      />
                  </Box> 
                </Box>

              </Grid2>
              }
              {equipmentAlert?.fllwActionType !== 'O1_WAIT' ? 
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.fllwActionType')}</Typography>
                  <div style={{padding:"10px"}}>{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)?.[0]?.title}</div>
                </Box>
              :
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.fllwActionType')}</Typography>
                  <Box >
                    {fllwActionTypes &&
                    <Controller
                        sx={{ m: 1, minWidth: "200px" }}
                        aria-invalid={!isDirty ? undefined : errors.fllwActionType ? "true" : "false"}
                        control={control}
                        name="fllwActionType"
                        render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                            style={{ minWidth: '200px' }}
                            label={t('message.common.subtitle.fllwActionType')}
                            register={register}
                            name={name}
                            isLabelView={false}
                            requiredMessage={t('message.common.error.text.fllwActionType.select')}
                            defaultValue={'O4_NORMAL'}
                            list={fllwActionTypes}
                        />
                        )}
                    />
                    }
                    {errors.fllwActionType && <small role="alert"><br></br>{errors.fllwActionType.message}</small>}
                  </Box>
                </Box>
              }
            </form>

            {equipmentAlert?.fllwActionType !== 'O1_WAIT' ? 
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <Button variant="contained" size="small" onClick={handleClose}>
                {t('message.common.btn.confirm')}
              </Button>
            </Stack>
            : 
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <Button variant="contained" size="small" onClick={handleSubmit(onSubmit)}>
                {t('message.common.btn.write')}
              </Button>
              <Button variant="contained" color="error" size="small" onClick={handleClose}>
                {t('message.common.btn.cancel')}
              </Button>
            </Stack>
            //: ""
            }

            {/* 후속조치 : 주의관찰 선택 */
              equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation?.remark === undefined && 
            <>
              <SectionTitle title={t('message.common.btn.observe.write')} />
            
              <form onSubmit={handleSubmit(onAttentionObservationSubmit)}>
                <Grid2>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.write.date')}</Typography>
                    <Box>
                      <Controller
                        control={control}
                        name="regYmd"
                        rules={{ required: t('message.common.error.text.observe.write.date.select') }}
                        render={({ field , fieldState }) => (
                          <CustomMuiDatePicker style={{width:"96%", textAlign:"center"}} field={field} fieldState={fieldState} />
                        )}
                      />
                    </Box>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.regUser')} ({t('message.common.subtitle.managerName')})</Typography>
                    <Box>
                      <TextField 
                        fullWidth 
                        placeholder={t('message.common.text.placeholder.enter.name')} 
                        {...register("regUser", { required : t('message.common.error.text.observe.writer.input') })} 
                        sx={inputStyle} 
                        error={!!errors.regUser} 
                        helperText={errors.regUser?.message}
                      />
                    </Box>
                  </Box>
                </Grid2>

                <Box sx={{ flex: 1, mt: 2 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.scheduled.endDate')}</Typography>

                  <Box>  
                    <Controller
                      control={control}
                      name="plannedEndYmd"
                      rules={{ required: t('message.common.error.text.observe.scheduled.endDate.input') }}
                      render={({ field , fieldState }) => (
                        <CustomMuiDatePicker field={field} fieldState={fieldState} />
                      )}
                    />
                  </Box>
                </Box>
                
                <Box sx={{ flex: 1, mt: 2 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>{t('message.common.subtitle.observe.detail')}</Typography>
                  <Box>
                    <TextField 
                      multiline 
                      rows={4} 
                      fullWidth 
                      placeholder={t('message.common.error.text.observe.detail.input')}
                      {...register("remark", { required : t('message.common.error.text.observe.detail.input') })} 
                      sx={inputStyle} 
                      error={!!errors.remark} 
                      helperText={errors.remark?.message} 
                    />
                  </Box>
                </Box>

                <Box sx={{ flex: 1, mt: 2 }}>
                  <Typography sx={{ fontSize: "0.85rem", color: "#a0aec0", mb: 1 }}>
                    {t('message.common.subtitle.status.report.file')} ({t('message.common.tabTitle.picture.data')})
                    <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px", marginLeft:"5px"}} onClick={addInputFile}>+</AddCircleOutlineIcon>
                  </Typography>
                  
                  {inputFiles && inputFiles.map(function(item, index) {
                  return (
                  <div key={index} style={{display:"flex", alignItems:"center", marginBottom:"6px"}}>
                      <input type="file" value={''} className="file-input" style={{width:"200px"}} onChange={e => handleInputFileChange(e, index)} />
                      { inputFiles[index] ? (
                          <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginLeft:"5px"}} onClick={() => deleteInputFile(item.id)}>-</RemoveCircleOutlineIcon>
                      ) : ''}
                      {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.id && <><FileDownloadIcon file={item.rFile} viewFileName={true} /></>)}
                  </div>
                  )
                  })}
                </Box>
              </form>

              <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
                <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onAttentionObservationSubmit)}>{t('message.common.btn.observe.write')}</LoadingButton>
                {/* <Button variant="contained" size="small" onClick={handleSubmit(onAttentionObservationSubmit)}>
                  주의관찰 등록
                </Button> */}
                <Button variant="contained" color="error" size="small" onClick={handleClose}>
                  {t('message.common.btn.cancel')}
                </Button>
              </Stack>
            </>
            }

            {/* 후속조치 : 유지보수 선택 */
              equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask?.trouble === undefined &&
              // true &&
            <>
              <SectionTitle title={t('message.common.btn.maintenance.write')} />

              <MaintenanceFormWrapper 
                id={maintenanceTask?.id} 
                onRefresh={onRefresh} 
                type={type} 
                handleCloseModal={handleClose} 
              />
              
              {/* <form onSubmit={mForm.handleSubmit(mForm.onFormSubmit)}>
              
                <MaintenanceCommonForm mForm={mForm} />

                <Divider />

                <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
                  <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onMaintenanceTaskSubmit)}>유지보수 등록</LoadingButton>
                  <Button variant="contained" color="error" size="small" onClick={handleClose}>
                    취소
                  </Button>
                </Stack>
              </form> */}
              </>
            }
            </CardContent>
            
            <Divider />

            {/* {equipmentAlert && equipmentAlert.fieldChkedAt && equipmentAlert.fieldChkUser && equipmentAlert.fllwActionType ? 
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <Button variant="contained" size="small" onClick={handleClose}>
                확인
              </Button>
            </Stack>
            : 
            // equipmentAlert == null ?
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <Button variant="contained" size="small" onClick={handleSubmit(onSubmit)}>
                등록
              </Button>
              <Button variant="contained" color="error" size="small" onClick={handleClose}>
                취소
              </Button>
            </Stack>
            //: ""
            } */}
          </MainCard>
        </Modal>
        }
      </>
    )
}

export default ConstantInspectionModal;
